import React from 'react'

import { Field, Input, Label, InputWithSuggestions } from 'components/form'

const EditEducation = ({ university, degree, onChange }) => (
  <React.Fragment>
    <Field>
      <Label htmlFor="university">Universitet</Label>
      <InputWithSuggestions
        id="university"
        suggestionsType="university"
        placeholder="F.eks. NTNU, UiO eller Westerdals"
        value={university}
        onChange={e => onChange({ key: 'university', value: e.target.value })}
        required
      />
    </Field>
    <Field>
      <Label htmlFor="degree">Grad</Label>
      <Input
        id="degree"
        type="text"
        placeholder=""
        value={degree}
        onChange={e => onChange({ key: 'degree', value: e.target.value })}
      />
    </Field>
  </React.Fragment>
)

export default EditEducation



// WEBPACK FOOTER //
// ./src/components/EditExperience/EditEducation.js